<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  
  <wiz-vgroup width="100%" height="100%" class="section-container"><!-- steps -->
    <multi-display code="visionStepMD" #gdSteps width="100%" height="100%" [config]="stepConfig">
      <wiz-hgroup target="title" width="100%">     
        <wiz-label [wizLabel]="'$.generator.steps.$'" class="titleLabel" width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>

  </wiz-vgroup>

  <wiz-vgroup width="100%" height="100%" class="section-container"><!-- restrictions -->
    



    <wiz-hgroup target="title" width="100%">     
      <wiz-icon #btnCreate [wizTooltip]="'$.generator.query.add.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="doAct('createQuery')">add</wiz-icon>
      <wiz-label [wizLabel]="'$.generator.query.$'" class="titleLabel" width="100%"></wiz-label>
    </wiz-hgroup>   
    <wiz-list
    #restrictionList
    height="100%"
    width="100%"
    [wizItemRenderer]="restrictionRenderer"
    id="restrictionList"
    [wizDataProvider]="restrictionDS"
    [wizLabelField]="'fullLabel'"
    ></wiz-list>


    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>

  </wiz-vgroup>


  <wiz-vgroup [visible]="false" width="200px" height="100%"><!--zone gauche, champ et conf globale-->
    
    <wiz-list 
    #freeList
    height="100%"
    width="100%"
    [wizItemRenderer]="renderer"
    id="freeList"
    [wizDataProvider]="dataSource"
    [wizLabelField]="'fullCode'"
    [dragEnabled]="true"
  ></wiz-list>
  <filter-component  #mainFilter> </filter-component> 


    
    <wiz-vgroup width="100%" [visible]="false" class="section-container">


      <wiz-checkbox #cbShowDeleteCol [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
      <wiz-checkbox #cbShowDeleteRecurseCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
      <wiz-hgroup>
        <wiz-checkbox #cbShowSelectCol [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique [wizLabel]="'$.pivot.edit.select.unique.$'"></wiz-checkbox>
      </wiz-hgroup>
      <wiz-radio-group [wizValue]="1" #rgMassEditConfig>
        <wiz-radio-button [wizLabel]="'$.massedit.undefined.$'" [wizValue]="1"></wiz-radio-button>
        <wiz-radio-button [wizLabel]="'$.massedit.same.$'" [wizValue]="2"></wiz-radio-button>
        <wiz-radio-button [wizLabel]="'$.massedit.split.$'" [wizValue]="3"></wiz-radio-button>
      </wiz-radio-group>

    </wiz-vgroup>
  </wiz-vgroup>
  

  <wiz-vgroup #vgDetailZone [visible]="false" width="100%" height="100%">
    <!-- zone détail : poser les champs -->

    <wiz-list #lstGroup id="lstGroup" [visible]="false"></wiz-list>


    <wiz-hgroup width="100%" height="25%"><!-- zone lignes et colonnes -->

      <wiz-vgroup width="50%" height="100%" minHeight="100px" class="section-container"><!-- champs lignes -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-line</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.row.agg.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstRow
          id="lstRow"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>

      <!-- champs colonnes -->
      <wiz-vgroup width="50%" height="100%" minHeight="100px" class="section-container" [visible]="!isToolMode" ><!-- champs colonnes -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-column</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.column.agg.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstColumn
          id="lstColumn"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
      </wiz-vgroup>
    </wiz-hgroup>

    <wiz-hgroup width="100%" height="75%"><!-- zone mesures & filters -->

      <wiz-vgroup width="50%" height="100%" minHeight="100px" class="section-container"><!-- champs datas -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-formula</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.data.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        <wiz-list
          #lstData
          id="lstData"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
        <wiz-checkbox #cbRevert [wizLabel]="'$.pivot.revert.$'"></wiz-checkbox>
      </wiz-vgroup>

      <wiz-vgroup width="50%" height="100%" minHeight="100px"> <!-- filtres & contrôles d'intégrité-->
        <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container"><!-- champs filtres -->
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-filters</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          <wiz-list
            #lstFilter
            id="lstFilter"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>

        <wiz-vgroup width="100%" height="100%" minHeight="100px" class="section-container"><!-- zone contrôle d'intégrité -->
          <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
            <wiz-icon class="image-purple">icon-formula</wiz-icon>
            <wiz-label [wizLabel]="'$.pivot.edit.field.integrity.$'" class="smallTitleLabel"></wiz-label>
          </wiz-hgroup>
          
          <wiz-checkbox #cbDeleteIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.delete.$'"></wiz-checkbox>
          <wiz-list
            #lstIntegrity
            id="lstDeleteCheck"
            width="100%"
            height="100%"
            [wizLabelField]="'label'"
            [wizItemRenderer]="renderer"
            [dragEnabled]="true"
            [dropEnabled]="true"
            [enableSelfReorder]="true"
            [shopDropIndicator]="true"
            [dragMove]="true"
          ></wiz-list>
          <wiz-checkbox #cbUpdateIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.update.$'"></wiz-checkbox>
        </wiz-vgroup>


      </wiz-vgroup>


    </wiz-hgroup>

    
  </wiz-vgroup>
  <!-- fin zone détail -->
</wiz-hgroup>
